import { createAppState } from '../appState';
import { initClsDebug } from '../clsDebug';
import { createContext } from '../createContext';
import { renderApp } from '../renderApp';

export function runApp() {
  /* Контекст собирается один раз и отдаётся и в стор (третий аргумент thunk'ов), и в провайдер. */
  const context = createContext();

  const store = createAppState(context);

  renderApp(store, context);

  /* Временная диагностика CLS. Удалить вместе с services/clsDebug, когда причина найдена. */
  const state = store.getState();

  initClsDebug({
    isAuthenticated: Boolean(state.user?.isAuthenticated),
    abGroup: state.pageData?.abGroup ?? null,
  });
}
